export default __webpack_public_path__ + "static/media/total-males.620fd76e.png";